/**
 * API request status
 */
export enum ViewState {
	idle,
	busy,
	empty,
	error,
}
